import React from "react";
import {
  FaBullseye,
  FaEye,
  FaHeart,
  FaUsers,
  FaRocket,
  FaHandshake,
} from "react-icons/fa";
import "./MissionVisionSection.css";

const MissionVisionSection = () => {
  return (
    <section className="staffline-mv-section">
      <div className="container">

        {/* ===== HEADER ===== */}
        <div className="staffline-mv-header">
          <span className="staffline-mv-tag">Who We Are</span>
          <h2 className="staffline-mv-title">
            Driven by Purpose, Guided by Vision
          </h2>
          <p className="staffline-mv-desc">
            StaffLine Transport exists to make daily commuting reliable,
            comfortable, and safe for every worker in Ghana.
          </p>
        </div>

        {/* ===== MISSION & VISION CARDS ===== */}
        <div className="staffline-mv-grid">

          {/* Mission */}
          <div className="staffline-mv-card staffline-mv-card-navy">
            <div className="staffline-mv-icon">
              <FaBullseye />
            </div>
            <h3>Our Mission</h3>
            <p>
              To provide reliable, safe, and stress-free commuting for every
              worker through a subscription-based shuttle service built on
              trust, technology, and comfort.
            </p>
          </div>

          {/* Vision */}
          <div className="staffline-mv-card staffline-mv-card-orange">
            <div className="staffline-mv-icon">
              <FaEye />
            </div>
            <h3>Our Vision</h3>
            <p>
              To become Ghana's leading staff transport provider, expanding
              across major cities and setting the benchmark for corporate
              commuting solutions in West Africa.
            </p>
          </div>

        </div>

        {/* ===== PURPOSE PILLARS ===== */}
        <div className="staffline-mv-pillars">
          <div className="staffline-mv-pillar">
            <FaHeart />
            <h4>People First</h4>
            <p>We put workers at the center of every decision.</p>
          </div>
          <div className="staffline-mv-pillar">
            <FaUsers />
            <h4>Community</h4>
            <p>We build a network of commuters who trust us daily.</p>
          </div>
          <div className="staffline-mv-pillar">
            <FaRocket />
            <h4>Innovation</h4>
            <p>We use tech to make commuting smarter and simpler.</p>
          </div>
          <div className="staffline-mv-pillar">
            <FaHandshake />
            <h4>Integrity</h4>
            <p>We honor every promise — on time, every time.</p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MissionVisionSection;